/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import "./MobileFooter.styles.scss";
import React from "react";
import { FlatButton, Icon } from "components";
import BackArrow from "assets/icons/chevron-left.svg";
import { useViewport } from "utils/hooks";

import { useTranslation } from "react-i18next";
import PatientSubmissionPrivacySetting from "../PatientSubmissionPrivacySetting";
import PatientSubmissionGroupPrivacySetting from "../PatientSubmissionGroupPrivacySetting";

interface Props {
  isSubmitting: boolean;
  isFinalSection: boolean;
  onPrivacyChange: (value: boolean) => void;
  showBackButton: boolean;
  onBackClick: () => void;
  isPrivate: boolean;
  isInfosheet: boolean;
  isGroupPrivate: boolean;
  onGroupPrivacyChange: (value: boolean) => void;
  isGroup: boolean;
}
const MobileFooter = ({
  isSubmitting,
  isFinalSection,
  onPrivacyChange,
  showBackButton,
  onBackClick,
  isPrivate,
  isInfosheet,
  isGroupPrivate,
  onGroupPrivacyChange,
  isGroup,
}: Props) => {
  const { t } = useTranslation(["common"]);
  const { isMobile } = useViewport();
  if (!isMobile || isInfosheet) {
    return <></>;
  }
  return (
    <div className="patient-section-footer-nav">
      <div className="patient-section-footer-nav__back-button-wrapper">
        {showBackButton && (
          <div
            className="patient-section-footer-nav__back-button"
            onClick={onBackClick}
          >
            <div className="patient-section-footer-nav__back-button--icon">
              <Icon src={BackArrow} />
            </div>
            Back
          </div>
        )}
      </div>
      {isGroup && (
        <PatientSubmissionGroupPrivacySetting
          onGroupPrivacySettingChange={onGroupPrivacyChange}
          isGroupPrivate={isGroupPrivate}
        />
      )}
      <PatientSubmissionPrivacySetting
        onPrivacySettingChange={onPrivacyChange}
        isPrivate={isPrivate}
        isDisabled={isGroup && !isGroupPrivate}
      />

      <FlatButton disabled={isSubmitting} isLoading={isSubmitting}>
        {isFinalSection
          ? t("common_labels.submit_button")
          : t("common_labels.save_and_continue_button")}
      </FlatButton>
    </div>
  );
};

export default MobileFooter;
